export class UrlPathname {
  private pathname: string;
  private constructor(pathname: string) {
    const endsWithSlashRegExp = /\/$/;
    this.pathname = endsWithSlashRegExp.test(pathname) ? pathname : `${pathname}/`;
  }
  static create(pathname: string) {
    return new UrlPathname(pathname);
  }
  get value() {
    return this.pathname;
  }
}
